import React, { useEffect, useState, useContext } from 'react';
import TranslationForm from './TranslationForm';
import TranslationResults from './TranslationResults';
import { EwtsConverter } from './src/EwtsConverter.mjs';
import { useParser } from './useParser';
import ReactDOM from 'react-dom';
import './translation.scss';
import { Col, Row, Tab, Form } from 'react-bootstrap';
import TermDictionaryChooser from '../Terms/TermDictionaries/TermDictionaryChooser';
import { useDictionaryStore } from '../../hooks/useDictionaryStore';
import Tabs from 'react-bootstrap/Tabs';
import { useView } from '../../hooks/useView';
import { convertBoToWy } from '../common/utils';
import { useHistory } from '../../hooks/useHistory';

const WYLIE = '73|roman.scholar';
const TIBETAN = '75|pri.orig.sec.roman';

/*
Test searches:
    * གཞི་ཚད་མེད་པའི་ཡེ་ཤེས་ཀྱི་འཁོར་ལོ་གསལ་བ་
 */
export default function TranslationTool(props) {
    const termView = useView((state) => state['terms']).split('|')[1];
    const addPage = useHistory((state) => state.addPage);
    let target = document.getElementById('translationTool');
    const [showResults, setShowResults] = useState(false);
    const [tibPhrase, setTibPhrase] = useState('');
    const {
        dictInfo,
        getDictFilterValue,
        getDictsByLang,
        setDictionaries,
        parser,
    } = useDictionaryStore();
    useDictionaryStore();

    const ewts = new EwtsConverter();

    const getResults = (e) => {
        e.preventDefault();
        // console.log("parser in get results", parser);
        const inputtext = document.getElementById(
            'translationForm.tibetan'
        ).value;
        if (inputtext) {
            const tibin = ewts.to_unicode(inputtext);
            setTibPhrase(tibin);
            setShowResults(true);
            document.getElementById('tttmsg').classList.add('d-none');
        } else {
            document.getElementById('tttmsg').classList.remove('d-none');
        }
    };

    const resetForm = (e) => {
        e.preventDefault();
        setShowResults(false);
        setTibPhrase('');
    };

    const dfv = getDictFilterValue();

    const {
        isLoading: isParserLoading,
        data: parsedPhrase,
        isError: isParsingError,
        error: parseError,
    } = useParser(tibPhrase, dfv, false, { parser: parser });

    useEffect(() => {
        const tibdicts = getDictsByLang('bod');

        for (const dkey in tibdicts) {
            tibdicts[dkey].selected = true;
        }
        setDictionaries(tibdicts);
    }, [dictInfo]);

    useEffect(() => {
        addPage('terms', 'Translation Tool', '/translate/tibetan');
    }, []);

    if (isParserLoading) {
        return null;
    }
    // console.log('Parsed phrase is: ', parsedPhrase);
    const transtool = (
        <div id="transtool" className="container">
            <Row>
                <h1>Tibetan Translation Tool</h1>
            </Row>
            <Row className="ml-1">
                <TtHelperTabs />
            </Row>
            <Row id="tttmsg" className="mt-2 d-none text-danger">
                <Col xs={12}>You must enter some text to translate.</Col>
            </Row>
            <Row className="mt-2">
                <Col xs={12}>
                    <TranslationForm
                        submit={getResults}
                        reset={resetForm}
                        defval={
                            termView === 'roman.scholar'
                                ? convertBoToWy(tibPhrase, false)
                                : tibPhrase
                        }
                    />
                    {showResults && <TranslationResults data={parsedPhrase} />}
                </Col>
            </Row>
            <TranslationContextMenu />
        </div>
    );

    if (target instanceof HTMLElement) {
        return ReactDOM.createPortal(transtool, target);
    } else {
        return transtool;
    }
}

const TtHelperTabs = () => {
    const { dictTabClosed, setDictTabClosed } = useDictionaryStore();
    const [key, setKey] = useState(''); // Nothing selected initially

    const closeMe = (e) => {
        e.preventDefault();
        setKey(null);
    };

    useEffect(() => {
        setDictTabClosed(key === null);
    }, [key]);

    return (
        <div className="w-75">
            <Tabs
                id="transtool-tabs"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
            >
                <Tab eventKey="dicts" title="Dictionaries">
                    {key === 'dicts' && (
                        <div className="position-relative">
                            <a
                                title="Remove this word from result list"
                                className="mandala-tab-close"
                                onClick={closeMe}
                                href="#"
                            >
                                <span className="icon shanticon-cancel-circle"></span>
                            </a>
                            <TermDictionaryChooser lang="bod" />
                        </div>
                    )}
                </Tab>
                <Tab eventKey="dictsettings" title="Settings">
                    {key === 'dictsettings' && (
                        <div className="position-relative">
                            <DictDisplaySettings />
                        </div>
                    )}
                </Tab>
                <Tab eventKey="help" title="Help">
                    {key === 'help' && (
                        <div className="position-relative pr-2">
                            <a
                                title="Remove this word from result list"
                                className="mandala-tab-close pr-1"
                                onClick={closeMe}
                                href="#"
                            >
                                <span className="icon shanticon-cancel-circle"></span>
                            </a>
                            <TtInstructions />
                        </div>
                    )}
                </Tab>
            </Tabs>
        </div>
    );
};
/*
<div>
        <span style={{ marginRight: '0.5rem' }}>
          {isOpen ? '▼' : '▶'}
        </span>
 */

const DictDisplaySettings = () => {
    const { parser, setParser } = useDictionaryStore();
    useDictionaryStore();
    const { terms, setTermsView } = useView();
    // 75|pri.orig.sec.roman
    // 73|roman.scholar
    const [selectedOption, setSelectedOption] = useState('');
    const [selectedParser, setSelectedParser] = useState('java');
    const [revert2Wylie, setRevert2Wylie] = useState(false);

    const handleChange = (event) => {
        const selectedOption = event.target.value;
        setSelectedOption(selectedOption);
        let newoption;
        if (selectedOption === 'wyl') {
            newoption = WYLIE;
        } else {
            newoption = TIBETAN;
        }
        setTermsView(newoption);
        let viewSettings = JSON.parse(localStorage.getItem('userViewSettings'));
        viewSettings['terms'] = newoption;
        localStorage.setItem('userViewSettings', JSON.stringify(viewSettings));
        localStorage.setItem('savedViewSettings', 'true');
    };

    const handleParserChange = (event) => {
        // console.log("Radio clicked", event.target.value);
        setSelectedParser('java');
        setParser('java');
        localStorage.setItem('tttParser', 'java');

        // Re-instate to enable php parser
        // setSelectedParser(event.target.value);
        // setParser(event.target.value);
        // localStorage.setItem('tttParser', event.target.value);
    };

    const handleRevertWylie = (event) => {
        console.log('Revert clicked', event.target.checked);
        setRevert2Wylie(event.target.checked);
        localStorage.setItem('revert2Wylie', event.target.checked);
    };

    useEffect(() => {
        if (terms === WYLIE) {
            setSelectedOption('wyl');
        } else {
            setSelectedOption('tib');
        }
        let storedParser = localStorage.getItem('tttParser');
        if (!storedParser || storedParser !== 'java') {
            setSelectedParser('java');
            setParser('java');
        }
    }, [terms]);

    useEffect(() => {
        const r2w = localStorage.getItem('revert2Wylie') === 'true';
        setRevert2Wylie(r2w);
    }, []);

    /*
    useEffect(() => {
        setSelectedParser(parser);
    }, [parser]);
 */

    return (
        <div className="ml-4 mb-0 ">
            <Form as={Row}>
                <Form.Group
                    as={Col}
                    className="col-md-4"
                    controlId="tibViewSelect"
                >
                    <Form.Label className="d-inline-block pe-2">
                        View Tibetan in:
                    </Form.Label>{' '}
                    <Form.Control
                        as="select"
                        value={selectedOption}
                        onChange={handleChange}
                        className="d-inline-block w-auto lh-1"
                    >
                        <option value="wyl">Wylie</option>
                        <option value="tib">Tibetan Script</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group
                    as={Col}
                    controlId="parserSelect"
                    className="d-none"
                >
                    <div className="d-flex align-items-left gap-1">
                        {/* New parser radio buttons */}
                        <Form.Label className="pt-2 pr-2 w-auto d-inline-block">
                            Choose Parser:
                        </Form.Label>{' '}
                        <Form.Control
                            as="select"
                            value={selectedParser}
                            onChange={handleParserChange}
                            className="d-inline-block w-auto lh-1"
                        >
                            <option value="java">Java</option>
                            <option value="php">PHP</option>
                        </Form.Control>
                    </div>
                </Form.Group>
                <Form.Group as={Col} controlId="wylieRevert">
                    <div className="d-flex align-items-left gap-1">
                        {/* New parser radio buttons */}
                        <Form.Label className="pr-2 w-auto d-inline-block">
                            Revert back to Wylie on Latin keypress:
                        </Form.Label>{' '}
                        <Form.Check
                            type="checkbox"
                            value={revert2Wylie}
                            onChange={handleRevertWylie}
                            className="d-inline-block w-auto lh-1"
                        ></Form.Check>
                    </div>
                </Form.Group>
            </Form>
        </div>
    );
    // return <p>Terms setting is: {terms}</p>;
};

const TtInstructions = () => {
    return (
        <div id="instructionsCollapse">
            <div className="mt-2 p-3 border rounded bg-light">
                <p className="pr-2">
                    Enter a Tibetan word or phrase in either Unicode Tibetan or
                    Wylie transliteration, and press "Translate". A list of
                    Tibetan words with definitions will appear below.
                </p>
                <ul>
                    <li>
                        Click on the word itself to see its full entry in the
                        dictionary.
                    </li>
                    <li>
                        Click on a particular dictionary name to display only
                        its definition.
                    </li>
                    <li>
                        Click on the{' '}
                        <span className="icon shanticon-cancel-circle"></span>{' '}
                        at the far right margin to remove the whole term from
                        the list.
                    </li>
                    <li>
                        Click on the “Dictionaries” tab to see and edit the list
                        of selected dictionaries.
                    </li>
                    <li>
                        Use the Settings tab to display Tibetan in Wylie
                        transliteration.
                    </li>
                </ul>
                <p>
                    For a visual representation of how to use the translation
                    tool, see{' '}
                    <a
                        href="https://thlib.org/audio-video/#/audio-video/42284"
                        target="_blank"
                    >
                        this video
                    </a>
                    .{' '}
                </p>
                <p>
                    <strong>Note:</strong> This new version of the translation
                    tool is constantly being updated and improved. If the tool
                    fails to load properly after some time, this is because your
                    browser has cached an older version that no longer exists.
                    To resolve this, one needs to do a hard refresh of the page:
                </p>
                <ul>
                    <li>
                        <em>For Windows</em>: Hold down the Ctrl key and press
                        Shift + R, or you can use Ctrl + F5.{' '}
                    </li>
                    <li>
                        <em>For Mac</em>: Hold down the Command (⌘) and Shift
                        keys, then press R.
                    </li>
                    <li>
                        <em>For Safari</em> specifically, you can also press
                        Option + Command + E to empty the cache, then click the
                        reload button.
                    </li>
                </ul>
                <p>
                    For instructions on how to run the Translation Tool locally
                    on your computer, see these{' '}
                    <a
                        href="https://github.com/tibetan-nlp/ttt?tab=readme-ov-file#tibetan-translation-tool"
                        target="_blank"
                    >
                        installation instructions on Github
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};

function TranslationContextMenu() {
    useEffect(() => {
        if (document?.addEventListener) {
            document.addEventListener('mousedown', (e) => {
                // If it's a right-click (button === 2), save selection *before* it disappears
                //console.log("Mousedown", e.which, e.keyCode, e.ctrlKey, e);
                if (e.ctrlKey) {
                    //console.log('Control key pressed!');
                    const selection = window.getSelection().toString().trim();
                    if (selection) {
                        // console.log("Setting last selection", selection);
                        localStorage.setItem('lastTransSel', selection);
                    }
                }
            });

            document.addEventListener('contextmenu', (e) => {
                const lastSelection = localStorage.getItem('lastTransSel');
                // console.log('last sel', lastSelection);
                if (lastSelection) {
                    e.preventDefault();
                    const menu = document.getElementById('customMenu');
                    menu.style.top = `${e.pageY}px`;
                    menu.style.left = `${e.pageX}px`;
                    menu.style.display = 'block';
                }
            });

            // Hide menu when clicking elsewhere
            document.addEventListener('click', () => {
                // document.getElementById('customMenu').style.display = 'none';
            });

            document
                .getElementById('translateSel')
                .addEventListener('click', () => {
                    //document.getElementById('customMenu').style.display =
                    //    'none';
                    const lastSelection = localStorage.getItem('lastTransSel');
                    document.getElementById('translationForm.tibetan').value =
                        lastSelection;
                    localStorage.setItem('lastTransSel', '');
                    document.getElementById('tt-btn-submit').click();
                    window.scrollTo(0, 0);
                });
        }
    }, []);

    return (
        <div>
            <div id="customMenu" className="custom-menu">
                <button id="translateSel">Translate Selection</button>
            </div>
        </div>
    );
}
